export enum OrderAccessInviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
}

export enum OrderAccessRole {
  VIEWER = 'VIEWER',
  MANAGER = 'MANAGER',
}

export enum OrderAccessStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum ROLE_LABEL {
  VIEWER = 'Viewer',
  MANAGER = 'Editor',
}

export type OrderAccessOption = {
  value: OrderAccessRole
  description: string
}
